import React from 'react';
import PropTypes from 'prop-types';
import css from './CwPodGrid.scss';
import cx from 'classnames';
import cwPodGridLoader from './CwPodGridLoader';

const CwPodGrid = (props) => {
  return (
    <div className={cx(css.podGrid, { [css.defaultLayout]: !props.customLayout })}>
      {props.loader(props)}
    </div>);
};

CwPodGrid.propTypes = {
  maxColumns: PropTypes.number,
  customLayout: PropTypes.bool,
  loader: PropTypes.func,
};

CwPodGrid.defaultProps = {
  maxColumns: 2,
  loader: cwPodGridLoader
};

export default CwPodGrid;


// WEBPACK FOOTER //
// ./src/components/cwpodgrid/CwPodGrid.jsx